import { FC } from 'react';
import { Tab, TabList, Tabs } from '@chakra-ui/react';
import { scroller } from 'react-scroll';
import { useTranslation } from 'next-i18next';

import { EventType } from '@lib/types';

const EventTab = ({ children, scrollTo }: any) => {
  const handleTabClick = () => {
    scroller.scrollTo(scrollTo, {
      duration: 600,
      smooth: true,
    });
  };

  return (
    <Tab
      height="64px"
      color="#666"
      _selected={{
        color: 'brand.500',
        bg: '#fff',
        borderBottom: `2px solid`,
        borderBottomColor: 'brand.500',
      }}
      _focus={{
        outline: 'none',
      }}
      onClick={handleTabClick}
    >
      {children}
    </Tab>
  );
};

type Props = {
  event: EventType;
};

const EventTabs = ({ event }: Props) => {
  const { t } = useTranslation(['event']);

  return (
    <Tabs>
      <TabList border="none">
        <EventTab scrollTo="description">{t('event:Description')}</EventTab>
        {event.agendas?.length > 0 && (
          <EventTab scrollTo="agenda">{t('event:Agendas')}</EventTab>
        )}
        <EventTab scrollTo="notice">{t('event:Notices')}</EventTab>
        <EventTab scrollTo="host">{t('event:Host')}</EventTab>
      </TabList>
    </Tabs>
  );
};

export default EventTabs;
